module.exports = __webpack_public_path__ + "static/media/undraw_feeling_blue.2847311a.svg";